import { parseWKTPoint } from '../../../utils/geo'

export type LngLat = [number, number]

const finitePoint = (lon: number | undefined, lat: number | undefined): LngLat | null => {
  if (lon == null || lat == null || !Number.isFinite(lon) || !Number.isFinite(lat)) {
    return null
  }
  return [lon, lat]
}

const pointFromCommaPair = (value: string): LngLat | null => {
  const parts = value.split(',').map((part) => Number(part.trim()))
  if (parts.length !== 2 || parts.some((part) => !Number.isFinite(part))) {
    return null
  }
  const [first, second] = parts
  if (first >= 45 && first <= 48 && second >= 5 && second <= 11) {
    return [second, first]
  }
  if (second >= 45 && second <= 48 && first >= 5 && first <= 11) {
    return [first, second]
  }
  return [first, second]
}

export const pointFromGeoValue = (value: unknown): LngLat | null => {
  if (typeof value === 'string') {
    return parseWKTPoint(value) ?? pointFromCommaPair(value)
  }
  if (Array.isArray(value) && value.length >= 2) {
    return finitePoint(Number(value[0]), Number(value[1]))
  }
  if (value && typeof value === 'object' && 'lat' in value && 'lon' in value) {
    const point = value as { lat?: number; lon?: number }
    return finitePoint(point.lon, point.lat)
  }
  return null
}

export const listingZoomTarget = (
  listing?: {
    geo_center?: unknown
    geo_center_popety?: unknown
  } | null,
  linkedLand?: { geo_center?: { lat?: number; lon?: number } | null } | null
): LngLat | null => {
  const linked = finitePoint(linkedLand?.geo_center?.lon, linkedLand?.geo_center?.lat)
  if (linked) return linked
  return pointFromGeoValue(listing?.geo_center_popety) ?? pointFromGeoValue(listing?.geo_center)
}

export const transactionZoomTarget = (
  transaction?: {
    transaction_properties?: Array<{ land_geo_center?: unknown }> | null
  } | null
): LngLat | null => {
  const properties = transaction?.transaction_properties ?? []
  for (const property of properties) {
    const point = pointFromGeoValue(property.land_geo_center)
    if (point) return point
  }
  return null
}

export const permitZoomTarget = (
  permit?: {
    geo_center?: unknown
  } | null
): LngLat | null => pointFromGeoValue(permit?.geo_center)
